import { IDispatchProps, IFormData } from './interfaces'
import { ActivityItems, ActivityUpdateItem, ITimelineResponse } from '../../components/v2/activity-timeline'
import {ORDERS_FORM_ALERT} from "../order/actions";

export const CLAIM_FORM_LOADING = 'CLAIM_FORM_LOADING'
export const CLAIM_DATA = 'CLAIM_DATA'
export const CLAIM_FORM_FAILED = 'CLAIM_FORM_FAILED'
export const CLAIM_FORM_ALERT = 'CLAIM_FORM_ALERT'
export const CLAIM_FORM_ID_UPDATE = 'CLAIM_FORM_ID_UPDATE'
export const CLAIM_TIMELINE_LOADING = 'CLAIM_TIMELINE_LOADING'
export const CLAIM_TIMELINE_DATA = 'CLAIM_TIMELINE_DATA'
export const CLAIM_TIMELINE_FAILED = 'CLAIM_TIMELINE_FAILED'
export const CLAIM_TIMELINE_CLEAR = 'CLAIM_TIMELINE_CLEAR'
export const CLAIM_TIMELINE_ADD_ITEM = 'CLAIM_TIMELINE_ADD_ITEM'
export const CLAIM_TIMELINE_UPDATE_ITEM = 'CLAIM_TIMELINE_UPDATE_ITEM'
export const CLAIM_TIMELINE_DELETE_ITEM = 'CLAIM_TIMELINE_DELETE_ITEM'
export const CLEAR_CLAIM_DATA = 'CLEAR_CLAIM_DATA'

/* ============== CLAIM_FORM ============== */
export function setClaimFormLoading() {
  return async dispatch => {
    dispatch({ type: CLAIM_FORM_LOADING })
  }
}

export function clearClaimData() {
  return async dispatch => {
    dispatch({ type: CLEAR_CLAIM_DATA })
  }
}

export function setClaimFormData(data: IFormData) {
  return async dispatch => {
    dispatch({ type: CLAIM_DATA, payload: data })
  }
}

export function setClaimFormFailed(error: string) {
  return async (dispatch: IDispatchProps) => {
    dispatch({ type: CLAIM_FORM_FAILED, payload: error })
  }
}

export function setClaimFormAlert(alert?: null | string) {
  return async dispatch => {
    dispatch({ type: CLAIM_FORM_ALERT, payload: alert })
  }
}
export function setClaimId(id: string) {
  return async dispatch => {
    dispatch({ type: CLAIM_FORM_ID_UPDATE, payload: id })
  }
}
/* ============== end Claim_FORM ============== */

/* ============== Claim_TIMELINE ============== */
export function setClaimTimelineLoading() {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_LOADING })
  }
}

export function setClaimTimelineData(formData: ITimelineResponse) {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_DATA, payload: formData })
  }
}

export function setClaimTimelineFailed(error: string) {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_FAILED, payload: error })
  }
}

export function setClaimTimelineClear() {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_CLEAR })
  }
}

export function addClaimTimeLineItem(activityItems: ActivityItems[]) {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_ADD_ITEM, payload: activityItems })
  }
}

export function updateClaimTimeLineItem(activityItem: ActivityUpdateItem) {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_UPDATE_ITEM, payload: activityItem })
  }
}

export function deleteClaimTimeLineItem(activityItem: ActivityUpdateItem) {
  return async dispatch => {
    dispatch({ type: CLAIM_TIMELINE_DELETE_ITEM, payload: activityItem })
  }
}
/* ============== end Claim_TIMELINE ==============  */
